import React from 'react'
import formatMessage from 'format-message'
import classnames from 'classnames'

import SecondaryToolbarButton from '../../SecondaryToolbarButton'
import TextSizeIcon from '../../icons/TextSizeIcon'

const buttonSize = {
  Small: 10,
  Medium: 15,
  Large: 18,
}

export default function TextSizeButton({ isSelected, onCurrentTextSizeChange, font, sizeValue }) {
  const handleClick = (_event) => {
    if (!isSelected) {
      onCurrentTextSizeChange(font)
    }
  }

  const textSize = sizeValue ? formatMessage(sizeValue) : undefined

  const ariaLabel = formatMessage('Annotation markup text size {textSize}', {
    textSize,
  })

  const className = classnames('TextSizeButton', {
    selected: isSelected,
  })

  const buttonDimensions = buttonSize[sizeValue]

  return (
    <SecondaryToolbarButton
      title={textSize}
      ariaLabel={ariaLabel}
      onClick={handleClick}
      className={className}
    >
      {() => (
        <div className="TextSizeButton-outer">
          <TextSizeIcon height={buttonDimensions} width={buttonDimensions} />
        </div>
      )}
    </SecondaryToolbarButton>
  )
}
